import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from './actions';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Templates from './pages/Templates';
import Usecases from './pages/Usecases';
import Aboutus from './pages/Aboutus';
import Contact from './pages/Contact';
import NoMatch from './pages/NoMatch';
import setTranslate from './hocs/Trans';
import languageConfig from './config/supported_languages';

class App extends Component {

    constructor(props) {
        super(props)
        this.state = {}
        this.trans = this.trans.bind(this)
    }

    componentDidMount() {
        typeof window !== undefined &&  Object.prototype.toString.call(window.loadMessengerFrame)  === "[object Function]" && window.loadMessengerFrame();
        document.body.addEventListener('click', function(e) {
            const EXPECTED_LIST = ['A', 'BUTTON'];
            if(EXPECTED_LIST.indexOf(e.target.nodeName) === -1) {
                Array.from(document.getElementsByClassName('dropdown-menu')).map(item => {
                    if(getComputedStyle(item).display != 'none') item.style.display = 'none';
                });
            }
        });
    }

    trans(string) {
        if(this.props.lang !== null && this.props.lang !== '') {
            try {
                let dic = require(`./config/lang/${this.props.lang}.json`)
                let copStr = string.slice().trim();
                copStr = copStr.toLocaleLowerCase().replace(new RegExp(' ', 'g'), '_');
                copStr = copStr.replace('.', '').replace('\'', '');
                let transVal =  dic[copStr];
                if(!!transVal) {
                    return transVal;
                }
                throw new Error("'Translate." + this.props.lang + "' keyword (" + copStr + ") is not defined!");
            } catch (e) {
                return string;
            }
        }
    }

    render() {
        const supportsHistory = 'pushState' in window.history
        let langsCode = languageConfig.languages_code.slice();
        return (
            <BrowserRouter forceRefresh={!supportsHistory}>
                <Switch>
                    <Route
                        exact
                        path="/"
                        component={setTranslate(Home, this.trans, 'Home')}
                    />
                    <Route
                        exact
                        path={'/:lang' + '(' + langsCode.join('|') + ')'}
                        component={setTranslate(Home, this.trans, 'Home')}
                    />

                    <Route
                        path={'/:lang' + '(' + langsCode.join('|') + ')' + '/pricing'}
                        component={setTranslate(Pricing, this.trans, 'Pricing')}
                    />

                    <Route
                        path={'/:lang' + '(' + langsCode.join('|') + ')' + '/templates'}
                        component={setTranslate(Templates, this.trans, 'Templates')}
                    />

                    <Route
                        path={'/:lang' + '(' + langsCode.join('|') + ')' + '/usecases'}
                        component={setTranslate(Usecases, this.trans, 'Use Cases')}
                    />
                    <Route
                        path={'/:lang' + '(' + langsCode.join('|') + ')' + '/aboutus'}
                        component={setTranslate(Aboutus, this.trans, 'About Us')}
                    />
                    <Route
                        path={'/:lang' + '(' + langsCode.join('|') + ')' + '/contact'}
                        component={setTranslate(Contact, this.trans, 'Contact Us')}
                    />
                    <Route
                        component={NoMatch}
                    />
                </Switch>
            </BrowserRouter>
        );
    }
};


export default connect(state => ({
    lang: state.app.lang
}), actions)(App);




// WEBPACK FOOTER //
// ./src/App.js